<template>
  <div class="package-item">
    <div class="package d-flex align-items-center flex-wrap">
      <Select :options="collectionOptions" :value="collection.package" @changeValue="handleChangePackage" placeholder="Package"></Select>
      <input type="text" class="input-value" :value="collection.label" @change="handleChangeLabel($event.target.value)" placeholder="Label" />
      <span class="flex-1"></span>
      <i @click="removeItem" class="icon remove ti ti-square-rounded-minus"></i>
      <AceEditor v-if="collection.package == 'list'" :value="String(collection.value || '')" lang="json" @change="handleChangeValue" :placeholder="placeholder()" />
    </div>
  </div>
</template>

<script>
import AceEditor from '@/components/AceEditor.vue'
export default {
  components: {
    AceEditor
  },
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    collections() {
      return this.more.collections || {}
    },
    collectionOptions() {
      let collections = []
      Object.entries(this.collections).forEach(([id, text]) => {
        if (id != 'static') {
          collections.push({
            id,
            text
          })
        }
      })
      return collections
    },
    collection() {
      return this.config?.collection || {}
    },
    more() {
      return this.config?.more || {}
    }
  },
  methods: {
    placeholder() {
      return `{\n\t"key1": "value1",\n\t"key2": "value2"\n}`
    },
    handleChangePackage(e) {
      this.store.commit(`${this.storeId}.package`, e)
    },
    handleChangeLabel(e) {
      this.store.commit(`${this.storeId}.label`, e)
    },
    handleChangeValue(e) {
      this.store.commit(`${this.storeId}.value`, e)
    },
    removeItem() {
      const lastIndex = this.storeId.lastIndexOf('.')
      const baseStoreId = this.storeId.substring(0, lastIndex)
      const index = this.storeId.substring(lastIndex + 1)
      let actions = this.store.getter(baseStoreId, [])
      actions.splice(index, 1)
      this.store.commit(baseStoreId, actions)
    }
  },
  props: {
    config: Object
  }
}
</script>
